import { render, staticRenderFns } from "./StaffPaymentsView.vue?vue&type=template&id=3b1fe303&scoped=true"
import script from "./StaffPaymentsView.vue?vue&type=script&lang=js"
export * from "./StaffPaymentsView.vue?vue&type=script&lang=js"
import style0 from "./StaffPaymentsView.vue?vue&type=style&index=0&id=3b1fe303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1fe303",
  null
  
)

export default component.exports